import { render, staticRenderFns } from "./GameOverDialog.vue?vue&type=template&id=38a356d6&scoped=true"
import script from "./GameOverDialog.vue?vue&type=script&lang=js"
export * from "./GameOverDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a356d6",
  null
  
)

export default component.exports